<mat-form-field appearance="outline" class="no-line">
    <mat-select multiple class="select" [placeholder]="placeholder" [(ngModel)]="selectedSoftwareIds"
        disableOptionCentering>
        <mat-option (click)="SoftwareSelected()" [value]="software.softwareId" *ngFor="let software of softwares">
            {{ software.name }}
        </mat-option>
    </mat-select>
</mat-form-field>